import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueHtml2Canvas from "vue-html2canvas";
import EasySlider from "vue-easy-slider";

Vue.use(EasySlider);
Vue.use(VueAxios, axios);
Vue.use(VueHtml2Canvas);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
